export default __webpack_public_path__ + "static/daily-offer-f7927297345f0496b4a1a98500ce3673.png";